import { render, staticRenderFns } from "./taux-prestations.html?vue&type=template&id=838a08a0&scoped=true&external"
import script from "./taux-prestations.js?vue&type=script&lang=js&external"
export * from "./taux-prestations.js?vue&type=script&lang=js&external"
import style0 from "./taux-prestations.scss?vue&type=style&index=0&id=838a08a0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838a08a0",
  null
  
)

export default component.exports